









































import CommonBase from "../CommonBase";
import {Vue, Component, Inject, Prop} from "vue-property-decorator";
import  {QrcodeStream} from "vue-qrcode-reader";
import Api from "./Api";
import {ApiMessage} from "../../modules/models";
import {NativeApi, NativeApiException, NativeApiExceptionCode} from "@/modules/NativeBridge";

export enum ReaderType {
    BROWSER, NATIVEAPI
}
export enum QRReadStatus {
    NONE, STARTING, VALIDATING, SERVERPROCESSING, INVALID, CANCELLED
}

@Component({
    components: {
        "qrcode-stream": QrcodeStream,
    }
})
export default class QrReader extends CommonBase {
    @Inject()
    api!: Api;
    @Inject()
    nativeApi!: NativeApi;

    @Prop()
    cancelTo!: any;

    readonly readerTypeBROWSER = ReaderType.BROWSER;
    readertype: ReaderType | null = null;

    readonly statusNONE = QRReadStatus.NONE;
    readonly statusSTARTING = QRReadStatus.STARTING;
    readonly statusVALIDATING = QRReadStatus.VALIDATING;
    readonly statusSERVERPROCESSING = QRReadStatus.SERVERPROCESSING;
    readonly statusINVALID = QRReadStatus.INVALID;
    readonly statusCANCELLED = QRReadStatus.CANCELLED;


    initializing = true;
    url: string = "";
    errMsg: string | null = null;

    connecting = false;
    verifiedNumber: number | null = null;

    get paused() {
        return this.hasRead || this.errMsg != null;
    }

    get hasRead() {
        return this.url.length > 0;
    }
    get validUrl() {
        return this.url.length > 15 && this.url.indexOf("hmskort.no/v/") > 0;
    }

    get showProgress() {
        return this.errMsg == null && this.readerStatus > this.statusNONE && this.readerStatus <= this.statusINVALID;
    }
    get showRetry() {
        return (this.errMsg != null && this.errMsg !== this.cameraNotFoundMsg) ||
                this.readerStatus >= this.statusINVALID;
    }

    retry() {
        if(this.readertype === ReaderType.BROWSER) {
            const qr: any = this.$refs["qrcodeReader"];
            if (qr && qr.init) {
                this.errMsg = null;
                this.url = "";
                this.onInit(qr.init());
            } else {
                this.errMsg = "Kan ikke restarte. QrCodeReader ikke funnet";
            }
        } else { // Nativeapi
            this.nativeQRCodeRead();
        }
    }

    cameraNotFoundMsg = "Kamera ble ikke funnet. Du må bruke mobiltelefon/nettbrett/pc med kamera for å kunne scanne QR kode.";

    async onInit(promise) {
        this.initializing = true;
        try {
            await promise;
        } catch (error) {
            if (error.name === 'NotAllowedError') {
                // user denied camera access permisson
                this.errMsg = "Tilgang til kamera er blokkert av nettleser. Du må endre tilgangsinnstilling for å kunne scanne QR kode.";

            } else if (error.name === 'NotFoundError') {
                // no suitable camera device installed
                this.errMsg = this.cameraNotFoundMsg;

            } else if (error.name === 'NotSupportedError') {
                // page is not served over HTTPS (or localhost)
                this.errMsg = "Siden må leveres kryptert for å kunne bruke QR kode scanner";

            } else if (error.name === 'NotReadableError') {
                // maybe camera is already in use
                this.errMsg = "Kunne ikke lese data fra kameraet. Kameraet er kanskje i bruk i et annet program akkurat nå.";

            } else if (error.name === 'OverconstrainedError') {
                // passed constraints don't match any camera.
                // Did you requested the front camera although there is none?
                this.errMsg = "Kameraet tilfredstilte ikke ønskede parametre";

            } else {
                // browser might be lacking features (WebRTC, ...)
                this.errMsg = "Ukjent feil oppsto i QR kode scanner";
                throw error;
            }
        } finally {
            this.initializing = false;
        }
    }

    get devmode() {
        return Vue.config.devtools;
    }
    // Temporary for development without using camera to actually read qr code
    fakeQrRead() {
        const data = {
            source: "stream",
            content: "https://hmskort.no/v/fake9291012"
        };
        this.onDetect(Promise.resolve(data));
    }

    async onDetect(promise) {
        try {
            const data = await promise;
            if(data.source == "stream") {
                this.url = data.content;
                if(this.validUrl) {
                    await this.sendToServer();
                } else {
                    this.errMsg = "Ugylding url lest fra QR kode";
                }
            } else {
                this.errMsg = "Ugyldig kilde for bilde. Kun QR koder direkte fra kamera er tillatt.";
            }
        } catch (e) {
            this.errMsg = "QR kode scanning feilet";
            throw e;
        }
    }

    async sendToServer() {
        try {
            this.connecting = true;
            const reply: number | ApiMessage = await this.api.cardQrInit(this.url);
            if (reply instanceof ApiMessage) {
                if(reply.num == 99) {
                    this.errMsg = `hmskort.no støtter ikke QR-kode lesing av kort utstedt etter 1. januar 2020 ennå. Innregistrering i Anleggsterminal med nytt kort fungerer derfor ikke pr nå.`;
                } else {
                    this.errMsg = `Kan ikke registreres: ${reply.msg}`;
                }
            } else {
                this.verifiedNumber = reply as number;

                this.errMsg = null;
                // emit event with cardnumber returned
                this.$emit("card-pending", this.verifiedNumber);
            }
        } finally {
            this.connecting = false;
        }
    }

    readerStatus = this.statusNONE;
    async nativeQRCodeRead() {
        try {
            this.readerStatus = this.statusSTARTING;
            this.errMsg = null;
            const qrcode = await this.nativeApi.getQrcode();
            if (qrcode != null) {
                this.readerStatus = this.statusVALIDATING;
                this.url = qrcode;
                if (this.validUrl) {
                    this.readerStatus = this.statusSERVERPROCESSING;
                    await this.sendToServer();
                } else {
                    this.readerStatus = this.statusINVALID;
                    this.errMsg = "Ugyldig url lest fra QR kode";
                }
            } else {
                this.readerStatus = this.statusCANCELLED;
                // QR read cancelled in activity - navigate to cancelTo
                this.emitSnack(`QR kode leser avbrutt.`, "info");
            }
        } catch (err) {
            if(err instanceof NativeApiException && err.code === NativeApiExceptionCode.MISSING_PERMISSION_PROMPTABLE) {
                this.errMsg = `App ble ikke gitt rettigheter til kamera. Kan derfor ikke lese QR koder.`
            } else {
                this.errMsg = "QR kode scanning feilet";
                throw err;
            }
        }
    }

    created() {
        // Determine what readertype to use
        if(this.nativeApi.available && this.nativeApi.atleastVersion(0, 4, 0)) {
            this.readertype = ReaderType.NATIVEAPI;
            // Start the native app qr code reader and wait for the result.
            this.nativeQRCodeRead();
        } else {
            this.readertype = ReaderType.BROWSER;
        }
    }
}
